require('../../modules-optimized/carousel/pdp-gallery-native');
